import * as requestFromServer from "./superAdminServicesApis";
import Actions from "../../actions";

// super admin services -> get super admin services api
export const getSuperAdminServicesAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getSuperAdminServices(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_SUPER_ADMIN_SERVICES_LIST, {superAdminServices: response}));
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
